export class AccessLogHelper {
    static formatAccessTime(inputDate) {
        const date = new Date(inputDate);
        const today = new Date();
        const oneWeekAgo = new Date(
            today.getFullYear(),
            today.getMonth(),
            today.getDate() - 7
        );

        const isSameDay = (d1, d2) => {
            return d1.toDateString() === d2.toDateString();
        };

        const pastOptions = {
            month: 'long',
            day: 'numeric',
            weekday: 'long',
            hour: 'numeric',
            minute: 'numeric',
            hour12: true
        };

        if (isSameDay(date, today)) {
            const time = date.toLocaleTimeString('en-US', {
                hour: 'numeric',
                minute: 'numeric',
                hour12: true
            });
            return `Today, ${time}`;
        }

        if (date > oneWeekAgo) {
            const weekday = date.toLocaleDateString('en-US', { weekday: 'long' });
            const time = date.toLocaleTimeString('en-US', {
                hour: 'numeric',
                minute: 'numeric',
                hour12: true
            });
            return `${weekday} at ${time}`;
        }

        return date.toLocaleString('en-US', pastOptions);
    }

    static formatAccessCodeTime(inputDate) {
        const date = new Date(inputDate);
        const today = new Date();

        const isSameDay = (d1, d2) => {
            return d1.toDateString() === d2.toDateString();
        };

        const pastOptions = {
            month: 'short',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            hour12: true
        };

        if (isSameDay(date, today)) {
            const time = date.toLocaleTimeString('en-US', {
                hour: 'numeric',
                minute: 'numeric',
                hour12: true
            });
            return `Today, ${time}`;
        }

        return date.toLocaleString('en-US', pastOptions);
    }

    static buildVirtualGuardPayload({
        success,
        accessType,
        role,
        activePanel,
        callData,
        manualTarget,
        userData,
        member,
        consumerId,
        visitor,
        guestInviteVisitor,
        emergency,
        override,
        propertyId,
        accessVehicle,
        invite,
        note_type,
        denial_reason
    }) {
        const hasManualTarget = !!manualTarget?.locationId;
        const orgId = callData?.org_id || (hasManualTarget ? manualTarget.orgId || userData.active_org_id : activePanel?.orgId || userData.active_org_id);
        const targetContext = callData ? { call_id: callData.id } : hasManualTarget ? { location_id: manualTarget.locationId, ...(manualTarget.sublocationId ? { sublocation_id: manualTarget.sublocationId } : {} )} : { panel_id: activePanel?.id || '' };

        const guardAccess = !!emergency;

        const effectiveVisitor = visitor || guestInviteVisitor || null;

        const visitorPayload =
            effectiveVisitor &&
            (effectiveVisitor.name?.trim() || effectiveVisitor.company_name?.trim())
                ? {
                      name: (effectiveVisitor.name || '').trim(),
                      company_name: (effectiveVisitor.company_name || '').trim(),
                      ...(success
                          ? {
                                approved_by:
                                    effectiveVisitor?.approval?.approved_by ?? null,
                                approved_role: effectiveVisitor?.approval?.role ?? null
                            }
                          : {
                                denied_by: effectiveVisitor?.denial?.denied_by ?? null,
                                denied_role: effectiveVisitor?.denial?.role ?? null
                            }),
                      property_visitor_id: effectiveVisitor?.property_visitor_id || false,
                      photo_id: effectiveVisitor.photo_id ?? null
                  }
                : null;

        const inviteData =
            invite && (invite.invitorRole || invite.inviteType)
                ? {
                      invitor_id: invite.invitorId || '',
                      invitor_role: invite.invitorRole || '',
                      invite_type: invite.inviteType || '',
                      invite_id: invite.inviteId || ''
                  }
                : null;

        const payload = {
            org_id: orgId,
            ...targetContext,
            property_id: propertyId || '',
            role: role || 'visitor',
            creator_id: userData.uid,
            note_type: note_type || null,
            access_type: accessType || 'kiosk',
            consumer_id: visitorPayload ? '' : consumerId || '',
            first_name:
                (emergency || visitorPayload
                    ? visitorPayload?.name
                    : member?.first_name) ||
                member?.company_name ||
                '',
            last_name:
                (emergency || visitorPayload
                    ? visitorPayload?.company_name
                    : member?.last_name) || '',
            company: emergency
                ? userData.company_name || member?.company_name || ''
                : member?.company_name || '',
            emergency: !!emergency,
            override: !!override,
            guard_access: guardAccess,
            ...(visitorPayload ? { visitor: visitorPayload } : {}),
            ...(inviteData ? { invite: inviteData } : {}),
            ...(accessVehicle ? { vehicle: accessVehicle } : {})
        };

        if (denial_reason) {
            payload.denial_reason = denial_reason;
        }

        return payload;
    }

    static buildVirtualGuardFormData(payload) {
        const formData = new FormData();
        const { visitor, invite, vehicle, ...primitives } = payload;

        Object.entries(primitives).forEach(([key, value]) => {
            if (value === undefined || value === null) return;
            formData.append(
                key,
                typeof value === 'object' ? JSON.stringify(value) : String(value)
            );
        });

        if (visitor) {
            const { photo_id, ...visitorRest } = visitor;
            formData.append('visitor', JSON.stringify(visitorRest));
            formData.append('photo', photo_id);
        }
        if (invite) formData.append('invite', JSON.stringify(invite));
        if (vehicle) formData.append('vehicle', JSON.stringify(vehicle));

        return formData;
    }
}
